<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'companyProfile.membershipPlans.editPlan.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'common.requiredFieldsHint' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12 mb-4">
        <app-input-component
          [label]="('companyProfile.membershipPlans.addPlan.planName' | translate) + ' *'"
          [type]="'text'"
          [(value)]="name"
          [placeholder]="'companyProfile.membershipPlans.addPlan.planNamePlaceholder' | translate"
          [invalid]="isNameInvalid"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-4">
        <label class="form-label">{{ 'companyProfile.membershipPlans.addPlan.description' | translate }}</label>
        <textarea
          class="form-control"
          rows="2"
          [(ngModel)]="description"
          [placeholder]="'companyProfile.membershipPlans.addPlan.descriptionPlaceholder' | translate"
        ></textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-4">
        <label class="form-label">{{ 'companyProfile.membershipPlans.addPlan.coverageType' | translate }} *</label>
        <app-selectorini
          [options]="coverageOptions"
          [displayKey]="'display'"
          [(value)]="coverage"
          [invalid]="isCoverageInvalid"
        />
      </div>
      <div class="col-md-6 mb-4">
        <label class="form-label">{{ 'companyProfile.membershipPlans.addPlan.billingCycle' | translate }} *</label>
        <app-selectorini
          [options]="billingCycleOptions"
          [displayKey]="'display'"
          [(value)]="billing_cycle"
          [invalid]="isBillingCycleInvalid"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 mb-4">
        <app-input-component
          [label]="('companyProfile.membershipPlans.addPlan.price' | translate) + ' *'"
          [type]="'number'"
          [(value)]="price_cents"
          [placeholder]="'companyProfile.membershipPlans.addPlan.pricePlaceholder' | translate"
          [invalid]="isPriceInvalid"
        />
        @if (price_cents > 0) {
          <div class="text-muted small mt-1">
            {{ 'common.netAmountHint' | translate:{ amount: calculateNetAmount(price_cents), currency: currency || 'NOK' } }}
          </div>
        }
      </div>
      <div class="col-md-4 mb-4">
        <app-selectorini
          [options]="currencyOptions"
          [displayKey]="'name'"
          [valueKey]="'code'"
          [(value)]="currency"
          [label]="'companyProfile.membershipPlans.addPlan.currency' | translate"
          [floating]="true"
        />
      </div>
      @if (coverage === 'family') {
        <div class="col-md-4 mb-4">
          <app-input-component
            [label]="'companyProfile.membershipPlans.addPlan.maxChildren' | translate"
            [type]="'number'"
            [(value)]="max_children"
            [placeholder]="'companyProfile.membershipPlans.addPlan.maxChildrenPlaceholder' | translate"
          />
        </div>
      }
    </div>

    <!-- Benefits Section -->
    <div class="row">
      <div class="col-12 mb-4">
        <label class="form-label">{{ 'companyProfile.membershipPlans.addPlan.benefits' | translate }}</label>
        <p class="text-muted fs-7 mb-2">{{ 'companyProfile.membershipPlans.addPlan.benefitsHint' | translate }}</p>

        <div class="d-flex gap-2 mb-3">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="newBenefit"
            [placeholder]="'companyProfile.membershipPlans.addPlan.benefitPlaceholder' | translate"
            (keyup.enter)="addBenefit()"
          />
          <app-button
            [variant]="'primary'"
            [iconClass]="'fa fa-plus'"
            [disabled]="!newBenefit.trim()"
            (clicked)="addBenefit()"
          />
        </div>

        @if (benefits.length > 0) {
          <div class="benefits-list">
            @for (benefit of benefits; track $index) {
              <div class="benefit-item d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="fa fa-check-circle text-success me-2"></i>
                  <span>{{ benefit }}</span>
                </div>
                <app-button
                  [variant]="'danger'"
                  [size]="'sm'"
                  [iconClass]="'fa fa-times'"
                  (clicked)="removeBenefit($index)"
                />
              </div>
            }
          </div>
        } @else {
          <div class="text-muted text-center py-3 bg-light rounded">
            <i class="fa fa-gift me-2"></i>
            {{ 'companyProfile.membershipPlans.addPlan.noBenefits' | translate }}
          </div>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row w-100">
      <div class="col-12 d-flex justify-content-end gap-2">
        <app-button
          [variant]="'neutral'"
          [label]="'common.cancel' | translate"
          (clicked)="close()"
        />
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.updating' | translate) : ('companyProfile.membershipPlans.editPlan.updatePlan' | translate)"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
